// extracted by mini-css-extract-plugin
export var active = "_gz-7";
export var blink = "_gz-8";
export var dropDownSelector = "_gz-4";
export var dropDownWrapper = "_gz-3";
export var fakeCursor = "_gz-6";
export var fontSizeButton = "_gz-9";
export var formQuillEditor = "_gz-0";
export var pressed = "_gz-a";
export var qlBlank = "_gz-1";
export var textFormattingToolbar = "_gz-2";
export var textToolbarOption = "_gz-5";